module.exports = __webpack_public_path__ + "static/media/rectangle-20.87524524.svg";